import type { FC, SVGProps } from 'react';

type IconProps = SVGProps<SVGSVGElement>;

// ── Bottom navigation ────────────────────────────────────────────
// viewBox подобран так, чтобы наибольшая сторона глифа занимала 24px из 28:
// иконки из разных наборов и в исходном виде сильно расходились в размере

export const IconHome: FC<IconProps> = (props) => (
  <svg
    viewBox="23.5 3.52 28 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M36.7745 5.88663C37.1709 5.41986 37.8856 5.42073 38.2808 5.88846L49.2605 18.8835C49.8102 19.5341 49.3529 20.5371 48.5066 20.5371H46.5V28.4998C46.5 29.052 46.0523 29.4998 45.5 29.4998H40.5V22.4998H34.5V29.4998H29.5C28.9478 29.4998 28.5 29.052 28.5 28.4998V20.5371H26.4934C25.646 20.5371 25.1891 19.5318 25.7411 18.8816L36.7745 5.88663Z"
      fill="currentColor"
    />
  </svg>
);

export const IconCatalog: FC<IconProps> = (props) => (
  <svg
    viewBox="22.53 3.03 29.94 29.94"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M27 15.6665C27 11.1562 30.6563 7.49984 35.1666 7.49984C39.677 7.49984 43.3333 11.1562 43.3333 15.6665C43.3333 17.7663 42.5408 19.681 41.2387 21.1278C41.2385 21.1279 41.2384 21.1279 41.2383 21.128C41.0457 21.3419 40.842 21.5457 40.628 21.7383C40.628 21.7384 40.6279 21.7385 40.6278 21.7386C39.181 23.0407 37.2664 23.8332 35.1666 23.8332C30.6563 23.8332 27 20.1768 27 15.6665ZM41.7205 23.8704C39.9243 25.3073 37.6458 26.1665 35.1666 26.1665C29.3676 26.1665 24.6666 21.4655 24.6666 15.6665C24.6666 9.86751 29.3676 5.1665 35.1666 5.1665C40.9656 5.1665 45.6666 9.86751 45.6666 15.6665C45.6666 18.1457 44.8074 20.4242 43.3705 22.2205L49.9915 28.8415C50.4471 29.2971 50.4471 30.0358 49.9915 30.4914C49.5359 30.9471 48.7972 30.9471 48.3415 30.4914L41.7205 23.8704Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
  </svg>
);

export const IconPrescription: FC<IconProps> = (props) => (
  <svg
    viewBox="0.33 0.33 23.33 23.33"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.75 2C5.23122 2 4 3.23122 4 4.75V19.25C4 20.7688 5.23122 22 6.75 22H17.25C18.7688 22 20 20.7688 20 19.25V4.75C20 3.23122 18.7688 2 17.25 2H6.75ZM5.5 4.75C5.5 4.05964 6.05964 3.5 6.75 3.5H17.25C17.9404 3.5 18.5 4.05964 18.5 4.75V19.25C18.5 19.9404 17.9404 20.5 17.25 20.5H6.75C6.05964 20.5 5.5 19.9404 5.5 19.25V4.75ZM7.75 13.5C7.33579 13.5 7 13.8358 7 14.25C7 14.6642 7.33579 15 7.75 15H16.25C16.6642 15 17 14.6642 17 14.25C17 13.8358 16.6642 13.5 16.25 13.5H7.75ZM7.75 17C7.33579 17 7 17.3358 7 17.75C7 18.1642 7.33579 18.5 7.75 18.5H16.25C16.6642 18.5 17 18.1642 17 17.75C17 17.3358 16.6642 17 16.25 17H7.75Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
    <path
      d="M9.25 5.5C8.83579 5.5 8.5 5.83579 8.5 6.25V7H7.75C7.33579 7 7 7.33579 7 7.75V9.25C7 9.66421 7.33579 10 7.75 10H8.5V10.75C8.5 11.1642 8.83579 11.5 9.25 11.5H10.75C11.1642 11.5 11.5 11.1642 11.5 10.75V10H12.25C12.6642 10 13 9.66421 13 9.25V7.75C13 7.33579 12.6642 7 12.25 7H11.5V6.25C11.5 5.83579 11.1642 5.5 10.75 5.5H9.25Z"
      stroke="currentColor"
      strokeWidth="1.2"
    />
  </svg>
);

export const IconCart: FC<IconProps> = (props) => (
  <svg
    viewBox="21.17 1.67 32.66 32.66"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M35.9898 7.8412C36.4459 8.29614 36.4459 9.0427 35.9898 9.49764L32.1485 13.3354H42.8476L39.0063 9.49764C38.5502 9.0427 38.5502 8.29614 39.0063 7.8412C39.4625 7.38627 40.1997 7.38627 40.6558 7.8412L46.1465 13.3354H50.3296C50.9735 13.3354 51.4961 13.8604 51.4961 14.5019C51.4961 15.1435 50.9735 15.6684 50.3296 15.6684H50.136L48.3256 25.6304C48.0234 27.2868 46.5746 28.5 44.8832 28.5H30.1129C28.4215 28.5 26.9727 27.2868 26.6706 25.6304L24.8601 15.6684H24.6665C24.0226 15.6684 23.5 15.1435 23.5 14.5019C23.5 13.8604 24.0226 13.3354 24.6665 13.3354H28.8496L34.3403 7.8412C34.7964 7.38627 35.5337 7.38627 35.9898 7.8412ZM27.2305 15.6685L28.9651 25.2105C29.0654 25.7588 29.5495 26.167 30.113 26.167H44.8832C45.4467 26.167 45.9296 25.7588 46.0299 25.2105L47.7657 15.6685H27.2305ZM32.0562 18.0131C32.692 17.9082 33.2939 18.3398 33.3989 18.9813L33.9821 22.4809C34.0883 23.1108 33.659 23.7174 33.0244 23.8223C32.3887 23.9273 31.7868 23.4957 31.6818 22.8541L31.0985 19.3546C30.9924 18.7247 31.4217 18.1181 32.0562 18.0131ZM42.9398 18.0131C43.5744 18.1181 44.0036 18.7247 43.8975 19.3546L43.3142 22.8541C43.2092 23.4957 42.6073 23.9273 41.9716 23.8223C41.337 23.7174 40.9077 23.1108 41.0139 22.4809L41.5971 18.9813C41.7021 18.3398 42.304 17.9082 42.9398 18.0131ZM37.4981 18.0015C38.142 18.0015 38.6646 18.5264 38.6646 19.168V22.6675C38.6646 23.3091 38.142 23.834 37.4981 23.834C36.8542 23.834 36.3316 23.3091 36.3316 22.6675V19.168C36.3316 18.5264 36.8542 18.0015 37.4981 18.0015Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
  </svg>
);

export const IconProfile: FC<IconProps> = (props) => (
  <svg
    viewBox="22.53 3.03 29.94 29.94"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M37.5 30.8332C44.5876 30.8332 50.3333 25.0875 50.3333 17.9998C50.3333 10.9122 44.5876 5.1665 37.5 5.1665C30.4123 5.1665 24.6666 10.9122 24.6666 17.9998C24.6666 25.0875 30.4123 30.8332 37.5 30.8332ZM28.8919 24.6202C27.4805 22.7877 26.6411 20.4918 26.6411 17.9999C26.6411 12.0026 31.5028 7.14089 37.5001 7.14089C43.4973 7.14089 48.3591 12.0026 48.3591 17.9999C48.3591 20.4923 47.5193 22.7886 46.1073 24.6213C45.4631 24.0371 44.6398 23.6145 43.5562 23.2245C43.3939 23.1661 43.2275 23.1087 43.0199 23.0388L42.5142 22.8695C41.2844 22.4546 40.8493 22.191 40.7481 21.8575C40.7446 21.8463 40.7392 21.8255 40.7315 21.785C40.6877 21.554 40.6977 21.3013 40.7876 21.0916C40.8406 20.9679 40.9215 20.8578 41.0427 20.7565C42.4065 19.5253 43.094 18.1378 43.094 16.2452C43.094 12.9478 40.5141 10.4315 37.5 10.4315C34.4652 10.4315 31.906 12.9049 31.906 16.2452C31.906 18.1322 32.5756 19.4792 33.8908 20.7178C34.06 20.8605 34.145 20.965 34.2028 21.0745C34.3146 21.2866 34.329 21.5325 34.28 21.7588C34.2765 21.775 34.2735 21.7872 34.2717 21.7949C34.2695 21.8041 34.2689 21.8067 34.2707 21.8018C34.1733 22.1479 33.7698 22.3965 32.6327 22.7849L32.0501 22.9816C31.8071 23.064 31.614 23.1317 31.4249 23.2015C30.3594 23.5947 29.5361 24.0291 28.8919 24.6202ZM30.2364 26.0719C32.1604 27.8044 34.7071 28.8588 37.5001 28.8588C40.2924 28.8588 42.8385 27.8049 44.7624 26.0732C44.3316 25.6914 43.7345 25.3871 42.8876 25.0822C42.7402 25.0292 42.586 24.976 42.3904 24.9102L41.883 24.7403C40.0464 24.1206 39.2196 23.6197 38.8638 22.4469C38.8413 22.3772 38.8154 22.2778 38.7917 22.1526C38.681 21.5688 38.706 20.9361 38.9731 20.3134C39.1468 19.9083 39.4138 19.5449 39.7478 19.2666C40.6886 18.4166 41.1197 17.5466 41.1197 16.2452C41.1197 14.0494 39.4346 12.4059 37.5 12.4059C35.5408 12.4059 33.8804 14.0107 33.8804 16.2452C33.8804 17.5454 34.3014 18.3924 35.1972 19.2388C35.5193 19.5055 35.7698 19.8136 35.9491 20.1534C36.3076 20.8331 36.3485 21.535 36.2096 22.1766C36.1812 22.3079 36.1499 22.4124 36.1498 22.4009C35.839 23.5553 35.0351 24.0507 33.2708 24.6533L32.6845 24.8513C32.4566 24.9286 32.2787 24.9909 32.1086 25.0537C31.2715 25.3627 30.6709 25.6783 30.2364 26.0719Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
  </svg>
);

// ── Profile & misc ───────────────────────────────────────────────

export const IconLocation: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.5935 3.68745C8.33176 3.68745 5.68759 6.32824 5.68759 9.59338C5.68759 11.9811 6.7515 14.3012 8.06937 16.2333C9.34927 18.1232 10.8173 19.5744 11.5935 20.2831C12.3697 19.5744 13.8378 18.1232 15.1177 16.2333C16.4355 14.3012 17.4994 11.9811 17.4994 9.59338C17.4994 6.32824 14.8553 3.68745 11.5935 3.68745ZM4 9.59333C4 5.40013 7.39928 2 11.5933 2C15.7874 2 19.1867 5.40013 19.1867 9.59333C19.1867 12.4619 17.9203 15.1112 16.5138 17.1867C15.0998 19.2622 13.4883 20.8399 12.6733 21.5824C12.0565 22.1392 11.1301 22.1392 10.5134 21.5824C9.69838 20.8399 8.0869 19.2622 6.67285 17.1867C5.2664 15.1112 4 12.4619 4 9.59333ZM11.5938 7.90591C10.6623 7.90591 9.90634 8.66524 9.90634 9.59331C9.90634 10.5214 10.6623 11.2807 11.5938 11.2807C12.5252 11.2807 13.2812 10.5214 13.2812 9.59331C13.2812 8.66524 12.5252 7.90591 11.5938 7.90591ZM8.21852 9.59336C8.21852 7.72878 9.72959 6.21855 11.5933 6.21855C13.4571 6.21855 14.9681 7.72878 14.9681 9.59336C14.9681 11.4579 13.4571 12.9682 11.5933 12.9682C9.72959 12.9682 8.21852 11.4579 8.21852 9.59336Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
  </svg>
);

export const IconOrders: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M10.8134 4.26809C11.1718 4.62554 11.1718 5.21212 10.8134 5.56957L7.79522 8.58499H16.2017L13.1836 5.56957C12.8252 5.21212 12.8252 4.62554 13.1836 4.26809C13.5419 3.91064 14.1212 3.91064 14.4795 4.26809L18.7937 8.58499H22.0804C22.5863 8.58499 22.9969 8.99743 22.9969 9.50153C22.9969 10.0056 22.5863 10.4181 22.0804 10.4181H21.9283L20.5058 18.2453C20.2684 19.5468 19.1301 20.5 17.8011 20.5H6.19586C4.86688 20.5 3.72854 19.5468 3.49115 18.2453L2.06868 10.4181H1.91654C1.41061 10.4181 1 10.0056 1 9.50153C1 8.99743 1.41061 8.58499 1.91654 8.58499H5.20325L9.5174 4.26809C9.87577 3.91064 10.455 3.91064 10.8134 4.26809ZM3.93106 10.4181L5.29395 17.9153C5.37277 18.3461 5.75314 18.6669 6.19583 18.6669H17.801C18.2437 18.6669 18.6232 18.3461 18.702 17.9153L20.0658 10.4181H3.93106ZM7.7229 12.2603C8.22241 12.1778 8.69535 12.5169 8.77784 13.021L9.23611 15.7707C9.31951 16.2656 8.98223 16.7422 8.48363 16.8247C7.98412 16.9072 7.51118 16.568 7.42869 16.0639L6.97042 13.3143C6.88702 12.8194 7.2243 12.3428 7.7229 12.2603ZM16.2744 12.2603C16.773 12.3428 17.1103 12.8194 17.0269 13.3143L16.5686 16.0639C16.4861 16.568 16.0132 16.9072 15.5137 16.8247C15.0151 16.7422 14.6778 16.2656 14.7612 15.7707L15.2195 13.021C15.302 12.5169 15.7749 12.1778 16.2744 12.2603ZM11.9985 12.2511C12.5044 12.2511 12.9151 12.6636 12.9151 13.1677V15.9173C12.9151 16.4214 12.5044 16.8338 11.9985 16.8338C11.4926 16.8338 11.082 16.4214 11.082 15.9173V13.1677C11.082 12.6636 11.4926 12.2511 11.9985 12.2511Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
  </svg>
);

export const IconRelatives: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.4229 9.31055H18.9118V12.2229C18.9118 12.5498 18.6395 12.8172 18.3067 12.8172H12.6493V14.6895H15.1604C15.4932 14.6895 15.7654 14.9569 15.7654 15.2838V21.4056C15.7654 21.7325 15.4932 22 15.1604 22H8.9281C8.59531 22 8.32302 21.7325 8.32302 21.4056V15.2838C8.32302 14.9569 8.59531 14.6895 8.9281 14.6895H11.4392V12.8172H5.72121C5.38841 12.8172 5.11613 12.5498 5.11613 12.2229V9.31055H2.60507C2.27228 9.31055 2 9.04309 2 8.7162V2.59435C2 2.26746 2.27228 2 2.60507 2H8.83734C9.17013 2 9.44241 2.26746 9.44241 2.59435V8.7162C9.44241 9.04309 9.17013 9.31055 8.83734 9.31055H6.32628V11.6285H17.6714V9.31055H15.1604C14.8276 9.31055 14.5553 9.04309 14.5553 8.7162V2.59435C14.5553 2.26746 14.8276 2 15.1604 2H21.3926C21.7254 2 21.9977 2.26746 21.9977 2.59435V8.7162C22.028 9.04309 21.7557 9.31055 21.4229 9.31055ZM9.53317 20.8113H14.5553V15.8782H9.53317V20.8113ZM8.26252 3.18871H3.21015V8.12184H8.23226V3.18871H8.26252ZM20.8178 3.18871H15.7654V8.12184H20.7876V3.18871H20.8178Z"
      fill="currentColor"
    />
  </svg>
);

export const IconQuestion: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.5 11.75C21.5 17.1348 17.1348 21.5 11.75 21.5C6.36522 21.5 2 17.1348 2 11.75C2 6.36522 6.36522 2 11.75 2C17.1348 2 21.5 6.36522 21.5 11.75ZM3.5 11.75C3.5 16.3063 7.19365 20 11.75 20C16.3063 20 20 16.3063 20 11.75C20 7.19365 16.3063 3.5 11.75 3.5C7.19365 3.5 3.5 7.19365 3.5 11.75Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
    <path
      d="M8.7998 7.18948C8.97602 7.02979 9.16876 6.87835 9.37802 6.73517C9.58728 6.59199 9.81582 6.46534 10.0636 6.3552C10.3114 6.24506 10.5785 6.15971 10.8649 6.09913C11.1567 6.03305 11.4706 6.00001 11.8065 6.00001C12.2526 6.00001 12.6629 6.06334 13.0373 6.18999C13.4173 6.31665 13.7422 6.49838 14.012 6.73517C14.2874 6.97196 14.5021 7.25832 14.6563 7.59424C14.8105 7.92465 14.8876 8.29636 14.8876 8.70937C14.8876 9.12789 14.8243 9.49134 14.6976 9.79973C14.5765 10.1026 14.4223 10.3669 14.2351 10.5927C14.0478 10.8185 13.8413 11.0167 13.6155 11.1875C13.3953 11.3527 13.186 11.5096 12.9878 11.6583C12.795 11.807 12.6271 11.9557 12.4839 12.1043C12.3462 12.2475 12.2636 12.41 12.2361 12.5917L12.0791 13.839H10.9805L10.8649 12.4761C10.8373 12.2227 10.8814 12.0025 10.997 11.8152C11.1127 11.628 11.2614 11.4545 11.4431 11.2948C11.6303 11.1296 11.8368 10.9699 12.0626 10.8157C12.2884 10.6615 12.4976 10.4908 12.6904 10.3036C12.8831 10.1109 13.0456 9.8961 13.1777 9.6593C13.3099 9.417 13.376 9.13065 13.376 8.80024C13.376 8.57446 13.3319 8.3707 13.2438 8.18898C13.1557 8.00725 13.0346 7.85306 12.8804 7.7264C12.7262 7.59424 12.5445 7.49511 12.3352 7.42903C12.1259 7.35744 11.9029 7.32165 11.6661 7.32165C11.3357 7.32165 11.0549 7.36295 10.8236 7.44555C10.5923 7.52265 10.394 7.608 10.2288 7.70162C10.0691 7.79524 9.93697 7.88335 9.83234 7.96595C9.72771 8.04305 9.6396 8.08159 9.56801 8.08159C9.40831 8.08159 9.29267 8.01276 9.22108 7.87509L8.7998 7.18948ZM10.4023 16.1097C10.4023 15.961 10.4298 15.8205 10.4849 15.6884C10.54 15.5562 10.6143 15.4406 10.7079 15.3414C10.807 15.2423 10.9227 15.1652 11.0549 15.1102C11.187 15.0496 11.3302 15.0193 11.4844 15.0193C11.6331 15.0193 11.7735 15.0496 11.9057 15.1102C12.0378 15.1652 12.1535 15.2423 12.2526 15.3414C12.3517 15.4406 12.4288 15.5562 12.4839 15.6884C12.5445 15.8205 12.5747 15.961 12.5747 16.1097C12.5747 16.2638 12.5445 16.407 12.4839 16.5392C12.4288 16.6713 12.3517 16.787 12.2526 16.8861C12.1535 16.9852 12.0378 17.0623 11.9057 17.1174C11.7735 17.1725 11.6331 17.2 11.4844 17.2C11.3302 17.2 11.187 17.1725 11.0549 17.1174C10.9227 17.0623 10.807 16.9852 10.7079 16.8861C10.6143 16.787 10.54 16.6713 10.4849 16.5392C10.4298 16.407 10.4023 16.2638 10.4023 16.1097Z"
      fill="currentColor"
    />
  </svg>
);

export const IconDocument: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M7.375 3.58333C6.938 3.58333 6.58333 3.938 6.58333 4.375V18.625C6.58333 19.062 6.938 19.4167 7.375 19.4167H16.875C17.312 19.4167 17.6667 19.062 17.6667 18.625V9.125H14.5C13.1882 9.125 12.125 8.06179 12.125 6.75V3.58333H7.375ZM13.7083 4.70275L16.5472 7.54167H14.5C14.063 7.54167 13.7083 7.187 13.7083 6.75V4.70275ZM5 4.375C5 3.06321 6.06321 2 7.375 2H12.9167C13.1265 2 13.3283 2.08312 13.4764 2.23196L19.018 7.77362C19.1669 7.92167 19.25 8.12354 19.25 8.33333V18.625C19.25 19.9368 18.1868 21 16.875 21H7.375C6.06321 21 5 19.9368 5 18.625V4.375ZM8.95833 13.0833C8.95833 12.6463 9.313 12.2917 9.75 12.2917H12.125C12.562 12.2917 12.9167 12.6463 12.9167 13.0833C12.9167 13.5203 12.562 13.875 12.125 13.875H9.75C9.313 13.875 8.95833 13.5203 8.95833 13.0833ZM8.95833 16.25C8.95833 15.813 9.313 15.4583 9.75 15.4583H14.5C14.937 15.4583 15.2917 15.813 15.2917 16.25C15.2917 16.687 14.937 17.0417 14.5 17.0417H9.75C9.313 17.0417 8.95833 16.687 8.95833 16.25Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
  </svg>
);

export const IconSupport: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M12.0418 4.62876C7.99353 4.62876 4.71239 7.9099 4.71239 11.9582C4.71239 13.3638 5.10736 14.675 5.79226 15.7898L6.01295 16.149L4.63421 19.3658L7.85101 17.987L8.21097 18.2077C9.32504 18.8926 10.6362 19.2876 12.0418 19.2876C16.0901 19.2876 19.3712 16.0065 19.3712 11.9582C19.3712 7.9099 16.0901 4.62876 12.0418 4.62876ZM3.08363 11.9582C3.08363 7.01082 7.09445 3 12.0418 3C16.9892 3 21 7.01082 21 11.9582C21 16.9055 16.9892 20.9164 12.0418 20.9164C10.4798 20.9164 9.00906 20.5157 7.72885 19.8121L5.27594 20.8634C3.92407 21.4425 2.55754 20.0759 3.13656 18.7241L4.18793 16.2711C3.4843 14.9909 3.08363 13.5202 3.08363 11.9582ZM7.96991 10.3294C7.96991 9.87989 8.33475 9.51504 8.78429 9.51504H11.2274C11.677 9.51504 12.0418 9.87989 12.0418 10.3294C12.0418 10.779 11.677 11.1438 11.2274 11.1438H8.78429C8.33475 11.1438 7.96991 10.779 7.96991 10.3294ZM7.96991 13.5869C7.96991 13.1374 8.33475 12.7726 8.78429 12.7726H15.2993C15.7489 12.7726 16.1137 13.1374 16.1137 13.5869C16.1137 14.0365 15.7489 14.4013 15.2993 14.4013H8.78429C8.33475 14.4013 7.96991 14.0365 7.96991 13.5869Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
  </svg>
);

export const IconLogOut: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M5.74982 4H9.03091C9.28871 4 9.49963 4.21094 9.49963 4.46875V5.40625C9.49963 5.66406 9.28871 5.875 9.03091 5.875H5.74982C4.71471 5.875 3.87491 6.71484 3.87491 7.75V15.25C3.87491 16.2852 4.71471 17.125 5.74982 17.125H9.03091C9.28871 17.125 9.49963 17.3359 9.49963 17.5938V18.5312C9.49963 18.7891 9.28871 19 9.03091 19H5.74982C3.67961 19 2 17.3203 2 15.25V7.75C2 5.67969 3.67961 4 5.74982 4ZM14.7767 4.76172L14.0111 5.52734C13.8236 5.71484 13.8275 6.01562 14.0189 6.19531L18.4367 10.4844H8.71842C8.46062 10.4844 8.24969 10.6953 8.24969 10.9531V12.0469C8.24969 12.3047 8.46062 12.5156 8.71842 12.5156H18.4367L14.0189 16.8008C13.8315 16.9844 13.8275 17.2852 14.0111 17.4688L14.7767 18.2344C14.9603 18.418 15.2572 18.418 15.4408 18.2344L21.8623 11.8281C22.0459 11.6445 22.0459 11.3477 21.8623 11.1641L15.4408 4.75781C15.2572 4.57813 14.9603 4.57812 14.7767 4.76172Z"
      fill="currentColor"
    />
  </svg>
);

export const IconTrash: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11.25 4.5C10.836 4.5 10.5 4.836 10.5 5.25V6H13.5V5.25C13.5 4.836 13.164 4.5 12.75 4.5H11.25ZM15 6V5.25C15 4.00725 13.9928 3 12.75 3H11.25C10.0072 3 9 4.00725 9 5.25V6H5.25C4.836 6 4.5 6.336 4.5 6.75C4.5 7.164 4.836 7.5 5.25 7.5H5.32875L6.606 18.9983C6.73275 20.1383 7.69575 21 8.8425 21H15.1575C16.3043 21 17.2673 20.1383 17.3933 18.9983L18.6713 7.5H18.75C19.164 7.5 19.5 7.164 19.5 6.75C19.5 6.336 19.164 6 18.75 6H15ZM17.1623 7.5H6.83775L8.097 18.8325C8.13975 19.2128 8.46075 19.5 8.8425 19.5H15.1575C15.5392 19.5 15.8603 19.2128 15.903 18.8325L17.1623 7.5ZM10.5 9.75C10.914 9.75 11.25 10.086 11.25 10.5V16.5C11.25 16.914 10.914 17.25 10.5 17.25C10.086 17.25 9.75 16.914 9.75 16.5V10.5C9.75 10.086 10.086 9.75 10.5 9.75ZM13.5 9.75C13.914 9.75 14.25 10.086 14.25 10.5V16.5C14.25 16.914 13.914 17.25 13.5 17.25C13.086 17.25 12.75 16.914 12.75 16.5V10.5C12.75 10.086 13.086 9.75 13.5 9.75Z"
      fillRule="evenodd"
      clipRule="evenodd"
      fill="currentColor"
    />
  </svg>
);

export const IconPlus: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <line x1="12" y1="5" x2="12" y2="19" />
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export const IconMinus: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <line x1="5" y1="12" x2="19" y2="12" />
  </svg>
);

export const IconAvatar: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="9" r="3.5" stroke="currentColor" strokeWidth="1.8" />
    <path
      d="M5.5 19c0-3 2.9-5 6.5-5s6.5 2 6.5 5"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

// ── Chevrons ─────────────────────────────────────────────────────

export const IconChevronRight: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M9 6l6 6-6 6"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconChevronDown: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6 9l6 6 6-6"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

/** Аптека: квадрат с вырезанным крестом */
export const IconPharmacyCross: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.5 3h11A3.5 3.5 0 0 1 21 6.5v11a3.5 3.5 0 0 1-3.5 3.5h-11A3.5 3.5 0 0 1 3 17.5v-11A3.5 3.5 0 0 1 6.5 3Zm4.1 3.9v3.7H6.9v2.8h3.7v3.7h2.8v-3.7h3.7v-2.8h-3.7V6.9h-2.8Z"
    />
  </svg>
);

// ── Navigation arrows ────────────────────────────────────────────

export const IconArrowLeft: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M9.39198 6.26592C9.74653 6.62047 9.74653 7.19532 9.39198 7.54987L6.09975 10.8421H20.8554C21.3568 10.8421 21.7633 11.2486 21.7633 11.75C21.7633 12.2514 21.3568 12.6579 20.8554 12.6579H6.09975L9.39198 15.9501C9.74653 16.3047 9.74653 16.8795 9.39198 17.2341C9.03742 17.5886 8.46258 17.5886 8.10802 17.2341L3.26592 12.392C2.91136 12.0374 2.91136 11.4626 3.26592 11.108L8.10802 6.26592C8.46258 5.91136 9.03742 5.91136 9.39198 6.26592Z" />
  </svg>
);

export const IconArrowRight: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M17.0836 12.3984L10.1536 19.3348C9.93175 19.5551 9.57297 19.5551 9.3511 19.3348L8.4164 18.4068C8.19453 18.1865 8.19453 17.8303 8.4164 17.6101L14.0104 12L8.4164 6.38994C8.19453 6.16966 8.19453 5.81347 8.4164 5.59319L9.3511 4.66521C9.57297 4.44493 9.93175 4.44493 10.1536 4.66521L17.0836 11.6016C17.3055 11.8219 17.3055 12.1781 17.0836 12.3984Z" />
  </svg>
);

export const IconChevronLeft: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M15 18l-6-6 6-6"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconQr: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M8.66667 2H4C2.89543 2 2 2.89543 2 4V8.66667H8.66667V2ZM6.44444 6.44444H4.22222V4.22222H6.44444V6.44444ZM2 20C2 21.1046 2.89543 22 4 22H8.66667V15.3333H2V20ZM4.22222 17.5556H6.44444V19.7778H4.22222V17.5556ZM15.3333 2V8.66667H22V4C22 2.89543 21.1046 2 20 2H15.3333ZM19.7778 6.44444H17.5556V4.22222H19.7778V6.44444ZM10.8889 2H13.1111V6.44444H10.8889V2ZM10.8889 8.66667H13.1111V10.8889H10.8889V8.66667ZM2 10.8889H4.22222V13.1111H2V10.8889ZM6.44444 10.8889H10.8889V13.1111H6.44444V10.8889ZM15.3333 15.3333H17.5556V17.5556H15.3333V15.3333ZM10.8889 17.5556V19.7778H13.1111V15.3333H10.8889V17.5556ZM13.1111 19.7778H15.3333V22H13.1111V19.7778ZM13.1111 10.8889H15.3333V15.3333H13.1111V10.8889ZM19.7778 10.8889H17.5556V13.1111H19.7778V15.3333H22V10.8889H19.7778ZM19.7778 19.7778H17.5556V22H20C21.1046 22 22 21.1046 22 20V17.5556H19.7778V19.7778Z" />
  </svg>
);

export const IconSearch: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M11 19a8 8 0 1 0 0-16 8 8 0 0 0 0 16ZM21 21l-4.35-4.35"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconClose: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M18 6 6 18M6 6l12 12"
      stroke="currentColor"
      strokeWidth="1.8"
      strokeLinecap="round"
    />
  </svg>
);

export const IconNoInternet: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    strokeLinecap="round"
    strokeLinejoin="round"
    {...props}
  >
    <path d="M12 18l.01 0" stroke="currentColor" strokeWidth="2" />
    <path
      d="M9.172 15.172a4 4 0 0 1 5.656 0"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M6.343 12.343a7.963 7.963 0 0 1 3.864-2.14m4.163.155a7.965 7.965 0 0 1 3.287 2"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path
      d="M3.515 9.515a12 12 0 0 1 3.544-2.455m3.101-.92a12 12 0 0 1 10.325 3.374"
      stroke="currentColor"
      strokeWidth="2"
    />
    <path d="M3 3l18 18" stroke="currentColor" strokeWidth="2" />
  </svg>
);

export const IconAttach: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M21.44 11.05l-9.19 9.19a6 6 0 01-8.49-8.49l9.19-9.19a4 4 0 015.66 5.66l-9.2 9.19a2 2 0 01-2.83-2.83l8.49-8.48"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconSend: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M22 2L11 13M22 2L15 22L11 13L2 9L22 2Z"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconPill: FC<IconProps> = (props) => (
  <svg
    viewBox="28.5 100.5 15.5 15.5"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M36.1032 114.078C32.6161 115.897 28.4027 111.867 30.2086 108.288C30.3926 107.922 30.8128 107.408 31.4694 106.745C32.8105 105.393 34.1564 104.045 35.5071 102.703C38.8672 99.3616 44.5157 103.529 42.4204 107.718C42.2019 108.155 41.7684 108.696 41.1199 109.341C39.9769 110.479 38.8355 111.62 37.6957 112.763C37.027 113.435 36.4962 113.873 36.1032 114.078ZM34.403 105.355L38.9684 109.934C38.9769 109.943 38.9884 109.948 39.0002 109.948C39.0119 109.949 39.0231 109.944 39.0312 109.936L40.9144 108.06C41.2056 107.77 41.4346 107.423 41.5882 107.039C41.7419 106.655 41.8172 106.242 41.8099 105.823C41.8026 105.404 41.7128 104.987 41.5457 104.597C41.3786 104.206 41.1374 103.85 40.8359 103.547L40.7976 103.509C40.1887 102.898 39.3712 102.546 38.5248 102.528C37.6784 102.511 36.8726 102.83 36.2845 103.417L34.4013 105.293C34.3932 105.301 34.3888 105.312 34.3891 105.324C34.3894 105.335 34.3944 105.347 34.403 105.355ZM38.2035 110.546L33.7982 106.128C33.7681 106.097 33.7279 106.08 33.6864 106.079C33.6449 106.078 33.6056 106.093 33.5771 106.122L31.7505 107.941C31.4599 108.231 31.2304 108.576 31.0751 108.957C30.9199 109.338 30.8419 109.748 30.8456 110.162C30.8493 110.577 30.9347 110.989 31.0968 111.374C31.259 111.759 31.4947 112.109 31.7906 112.406L31.9173 112.533C32.5147 113.132 33.3209 113.474 34.1583 113.485C34.9958 113.495 35.7959 113.172 36.3828 112.587L38.2094 110.767C38.2379 110.739 38.2533 110.7 38.2522 110.658C38.2511 110.617 38.2336 110.577 38.2035 110.546Z"
      fill="currentColor"
    />
    <path
      d="M37.1403 104.49C36.4785 105.001 35.8856 104.101 36.5722 103.605C37.9433 102.616 39.3348 102.702 40.7467 103.862C41.1439 104.186 40.8243 104.8 40.344 104.752C40.2872 104.747 40.2374 104.726 40.1946 104.689C39.1555 103.787 38.1374 103.721 37.1403 104.49Z"
      fill="currentColor"
    />
  </svg>
);

export const IconCheck: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M3.5 8.5L6.5 11.5L12.5 4.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// Прочитано: две галочки внахлёст. Тот же угол и толщина, что у IconCheck,
// бокс шире на ширину сдвига
export const IconCheckDouble: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 20 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M2 8.5L5 11.5L11 4.5"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M8.5 11.2L9.5 12.2L18 3"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconCheckCircle: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M4.29167 7.29167L6.29167 9.29167L10.2917 5.29167M13.9583 7.29167C13.9583 10.9736 10.9736 13.9583 7.29167 13.9583C3.60977 13.9583 0.625 10.9736 0.625 7.29167C0.625 3.60977 3.60977 0.625 7.29167 0.625C10.9736 0.625 13.9583 3.60977 13.9583 7.29167Z"
      stroke="currentColor"
      strokeWidth="1.25"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export const IconFilters: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M17.6172 4.08203H11.0156V3.32031C11.0156 3.04102 10.7871 2.8125 10.5078 2.8125H9.49219C9.21289 2.8125 8.98438 3.04102 8.98438 3.32031V4.08203H2.38281C2.10352 4.08203 1.875 4.31055 1.875 4.58984V5.09766C1.875 5.37695 2.10352 5.60547 2.38281 5.60547H8.98438V6.36719C8.98438 6.64648 9.21289 6.875 9.49219 6.875H10.5078C10.7871 6.875 11.0156 6.64648 11.0156 6.36719V5.60547H17.6172C17.8965 5.60547 18.125 5.37695 18.125 5.09766V4.58984C18.125 4.31055 17.8965 4.08203 17.6172 4.08203ZM17.6172 14.2383H6.95312V13.4766C6.95312 13.1973 6.72461 12.9688 6.44531 12.9688H5.42969C5.15039 12.9688 4.92188 13.1973 4.92188 13.4766V14.2383H2.38281C2.10352 14.2383 1.875 14.4668 1.875 14.7461V15.2539C1.875 15.5332 2.10352 15.7617 2.38281 15.7617H4.92188V16.5234C4.92188 16.8027 5.15039 17.0312 5.42969 17.0312H6.44531C6.72461 17.0312 6.95312 16.8027 6.95312 16.5234V15.7617H17.6172C17.8965 15.7617 18.125 15.5332 18.125 15.2539V14.7461C18.125 14.4668 17.8965 14.2383 17.6172 14.2383ZM17.6172 9.16016H15.0781V8.39844C15.0781 8.11914 14.8496 7.89062 14.5703 7.89062H13.5547C13.2754 7.89062 13.0469 8.11914 13.0469 8.39844V9.16016H2.38281C2.10352 9.16016 1.875 9.38867 1.875 9.66797V10.1758C1.875 10.4551 2.10352 10.6836 2.38281 10.6836H13.0469V11.4453C13.0469 11.7246 13.2754 11.9531 13.5547 11.9531H14.5703C14.8496 11.9531 15.0781 11.7246 15.0781 11.4453V10.6836H17.6172C17.8965 10.6836 18.125 10.4551 18.125 10.1758V9.66797C18.125 9.38867 17.8965 9.16016 17.6172 9.16016Z"
      fill="currentColor"
    />
  </svg>
);

export const IconLocationArrow: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M16.2384 0C16.037 0 15.831 0.0386719 15.6271 0.12375L1.01016 6.86988C-0.676284 7.65703 -0.114135 10.1306 1.68481 10.1306H7.86915V16.315C7.86915 17.37 8.72028 18 9.58266 18C10.1909 18 10.8043 17.6871 11.1299 16.9896L17.8764 2.37234C18.3534 1.2266 17.3719 0 16.2384 0ZM9.55559 16.315V8.44418H7.86915L1.69993 8.46914C1.69044 8.45613 1.6834 8.42168 1.7168 8.40129L16.2437 1.69664C16.2652 1.71105 16.2887 1.73426 16.3031 1.7557L9.55559 16.315Z"
      fill="currentColor"
    />
  </svg>
);

/** Часы: режим работы точки */
export const IconClock: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="10" cy="10" r="7.5" />
    <path d="M10 5.8V10l2.8 1.7" />
  </svg>
);

export const IconPhone: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M6.4 3.2h-2c-.8 0-1.4.7-1.3 1.5.3 3 1.6 5.8 3.7 7.9 2.1 2.1 4.9 3.4 7.9 3.7.8.1 1.5-.5 1.5-1.3v-2c0-.7-.5-1.3-1.2-1.4l-1.8-.3c-.5-.1-1 .1-1.3.5l-.6.8a10.6 10.6 0 0 1-4.4-4.4l.8-.6c.4-.3.6-.8.5-1.3l-.3-1.8c-.1-.7-.7-1.2-1.4-1.2Z" />
  </svg>
);

/** Две стрелки в строке сортировки: вниз слева, вверх справа */
export const IconSortArrows: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.6"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M6.5 3.5v13M6.5 16.5l-3-3M6.5 16.5l3-3" />
    <path d="M13.5 16.5v-13M13.5 3.5l-3 3M13.5 3.5l3 3" />
  </svg>
);

/** Фургон в бейдже «Завтра»: заказ приедет со склада в пункт выдачи */
export const IconDelivery: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.5 4.5A1.5 1.5 0 0 1 3 3h7.5a1.5 1.5 0 0 1 1.5 1.5V6h2.19c.46 0 .89.21 1.17.57l2.06 2.6c.2.26.31.58.31.92v3.16a1.5 1.5 0 0 1-1.5 1.5h-.79a2.5 2.5 0 0 1-4.88 0H8.4a2.5 2.5 0 0 1-4.88 0H3A1.5 1.5 0 0 1 1.5 13.25V4.5Zm10.5 3v5.25h.31a2.5 2.5 0 0 1 3.88 0h.31V10.4L14.19 7.5H12ZM5.96 12.75a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Zm8.5 0a1.25 1.25 0 1 0 0 2.5 1.25 1.25 0 0 0 0-2.5Z"
      fill="currentColor"
    />
  </svg>
);

export const IconVoidPharma: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 48 48"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="24" cy="24" r="21" stroke="currentColor" strokeWidth="3" />
    <path d="M20 13h8v7h7v8h-7v7h-8v-7h-7v-8h7z" fill="currentColor" />
  </svg>
);

// ── Плитки услуг на Главной ──────────────────────────────────────
// Один outline-стиль на все три: stroke-width 1.7, скруглённые концы.

export const IconPharmacyPin: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12 21.2s6.8-5.9 6.8-11.2a6.8 6.8 0 1 0-13.6 0c0 5.3 6.8 11.2 6.8 11.2z" />
    <path d="M12 6.9v6.2M8.9 10h6.2" />
  </svg>
);

export const IconParcel: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M12 3.1l7.6 3.8v9.4L12 20.9l-7.6-3.6V6.9z" />
    <path d="M4.4 6.9L12 10.7l7.6-3.8" />
    <path d="M12 10.7v10.2" />
  </svg>
);

export const IconPeople: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="9.4" cy="9" r="3.2" />
    <path d="M3.6 19.2a5.8 5.8 0 0 1 11.6 0" />
    <path d="M16.4 6.4a3.2 3.2 0 0 1 0 5.9M17.6 14.2a5.2 5.2 0 0 1 3 4.8" />
  </svg>
);

// ── Состояния блока рецептов ─────────────────────────────────────
// Рисуются крупно (54px) поверх градиента, поэтому линия тоньше.

export const IconPrescriptionDoc: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M6 2.6h8.2L18.4 6.8V21a.6.6 0 0 1-.6.6H6.2a.6.6 0 0 1-.6-.6V3.2A.6.6 0 0 1 6 2.6z" />
    <path d="M13.8 3v3.6a.6.6 0 0 0 .6.6H18" />
    <path d="M11 10.2v3M9.5 11.7h3" />
    <path d="M8.6 16.2h6.8M8.6 18.6h4.3" />
  </svg>
);

export const IconAlert: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.4"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <circle cx="12" cy="12" r="9.2" />
    <path d="M12 7.4v5.4" />
    <path d="M12 16.4h.01" />
  </svg>
);

export const IconBell: FC<IconProps> = (props) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="1.7"
    strokeLinecap="round"
    strokeLinejoin="round"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path d="M18 9a6 6 0 1 0-12 0c0 3.2-.7 5-1.5 6.1-.4.6 0 1.4.8 1.4h13.4c.8 0 1.2-.8.8-1.4C18.7 14 18 12.2 18 9Z" />
    <path d="M10 20a2.2 2.2 0 0 0 4 0" />
  </svg>
);
